import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import VueGtag from "vue-gtag";

// Global site tag (gtag.js)
const ga_config = {
    config: { id: process.env.VUE_APP_GA_ID }
}

createApp(App).use(VueGtag, ga_config, router).use(store).use(router).mount('#app')
